<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ConfirmSyncInvoice"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <p>
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <ItpText
          wrap
        >
          Szinkronizálás után a számla már nem módosítható.
        </ItpText>
      </p>
    </ItpAlert>
    <ItpForm
      :id="formId"
      name="confirmSyncInvoice"
      ref="mainForm"
      @submit="evh_4186377094414664_submit($event, {})"
    >
      <ItpFormGroup
        name="copies"
        :label="'Print'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        label-cols-md="3"
        content-cols-md="3"
      >
        <ItpFormCheckbox
          name="copies"
          v-model="payload.print"
          required
          size="md"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="print_copies"
        :label="'Copies'|pgettext('InvoiceSync')"
        :labelAlign="labelAlign"
        label-cols-md="3"
        content-cols-md="3"
      >
        <ItpFormInput
          type="number"
          name="print_copies"
          v-model="payload.print_copies"
          required
          :disabled="!payload.print"
        >
        </ItpFormInput>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Create invoice'|pgettext('Button')"
      :disabled="!forms.confirmSyncInvoice || !forms.confirmSyncInvoice.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ConfirmSyncInvoice extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  payload!: any;

  async $$load_payload() {
    return {
      id: this.invoice.id,
      print: true,
      print_copies: 1,
      target: "remote",
    }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'payload', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        payload: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("ConfirmSyncInvoice.Title", "Create invoice"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7398_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7398, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_closeModal_7404_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_4186377094414664_closeModal_7404, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_4186377094414664_request_7402_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4186377094414664_request_7402, alias=submit
    return {
      operation: "issue_invoice",
      data: this.payload,
    }
  }

  async evh_4186377094414664_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7398: actions.CloseModalAction;
    evh_7315092382398562_close_7397: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_7400: actions.CloseComponentAction;
    evh_2248226175642056_close_7399: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_4186377094414664_closeModal_7404: actions.CloseModalAction;
    evh_4186377094414664_success_7403: actions.EventHandlerImpl;
    act_4186377094414664_request_7402: actions.RequestAction;
    evh_4186377094414664_submit_7401: actions.EventHandlerImpl;
    evh_4186377094414664_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_7406: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_7405: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7398 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7398_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7397 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7398,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7397],
      }
    );
    const act_2248226175642056_closeComponent_7400 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_7399 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_7400,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_7399],
      }
    );
    const act_4186377094414664_closeModal_7404 = new actions.CloseModalAction(
      {
        actionArgs: this.act_4186377094414664_closeModal_7404_getActionArgs,
        events: [],
      }
    );
    const evh_4186377094414664_success_7403 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_closeModal_7404,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_4186377094414664_request_7402 = new actions.RequestAction(
      {
        actionArgs: this.act_4186377094414664_request_7402_getActionArgs,
        displayName: "submit",
        events: [evh_4186377094414664_success_7403],
      }
    );
    const evh_4186377094414664_submit_7401 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_request_7402,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_4186377094414664_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_submit_7401],
      }
    );
    const act_1419464017721962_closeComponent_7406 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_7405 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_7406,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_7405],
      }
    );
    return {
      act_7315092382398562_closeModal_7398,
      evh_7315092382398562_close_7397,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_7400,
      evh_2248226175642056_close_7399,
      evh_2248226175642056_close,
      act_4186377094414664_closeModal_7404,
      evh_4186377094414664_success_7403,
      act_4186377094414664_request_7402,
      evh_4186377094414664_submit_7401,
      evh_4186377094414664_submit,
      act_1419464017721962_closeComponent_7406,
      evh_1419464017721962_clickPreventStop_7405,
      evh_1419464017721962_clickPreventStop,
      submit: act_4186377094414664_request_7402,
    }
  }
}

Vue.component("ConfirmSyncInvoice", ConfirmSyncInvoice);

</script>